import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DOMManagerService {
  public body() { return document.getElementById("bot-container"); }
  public header() { return document.getElementById("bot-header"); }
  public content() { return document.getElementById("bot-content"); }
  public footer() { return document.getElementById("bot-footer"); }

  public hideFooter() {
    const f = document.getElementById("bot-footer");
    if (f) {
      f.style.display = "none";
    }
  }

  public showFooter() {
    const f = document.getElementById("bot-footer");
    if (f) {
      f.style.display = "block";
    }
  }
  public hideHeader() {
    document.body.classList.add('header-hidden');
  }

  public showHeader() {
    document.body.classList.remove('header-hidden');
  }

  public createElementFromHTML(html: string): HTMLElement {
    const template = document.createElement('template');
    template.innerHTML = html.trim(); // trim nötig, sonst TextNodes
    return template.content.firstElementChild as HTMLElement;
  }

  public styleVar(key: string, value: string): void {
    document.querySelectorAll<HTMLElement>('*').forEach(el => {
      el.style.setProperty(key, value);
    });
  }

  public async loadExternalJS(url: string): Promise<void> {
    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = url;
      script.type = 'text/javascript';
      script.onload = () => resolve();
      script.onerror = () => reject(new Error(`Failed to load script: ${url}`));
      document.head.appendChild(script);
    });
  }

  public async loadExternalCSS(url: string): Promise<void> {
    return new Promise((resolve, reject) => {
      const link = document.createElement('link');
      link.href = url;
      link.rel = 'stylesheet';
      link.type = 'text/css';
      link.onload = () => resolve();
      link.onerror = () => reject(new Error(`Failed to load CSS: ${url}`));
      document.head.appendChild(link);
    });
  }

  public setBodyColor(color: string) {
    const body = document.getElementById("bot-container");
    if (body) {
      body.style.backgroundColor = color;
    }
  }
}
